/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { SessionErrorResponseCodeEnum } from 'client-code/session-manager';

export abstract class SessionErrorMapper {
    public static mapSessionErrorType(errorCode: string): string {
        let sessionErrorType = '';
        switch (errorCode) {
            case SessionErrorResponseCodeEnum.AuthenticationExpired:
                sessionErrorType = 'SESSION_AUTHENTICATION_EXPIRED_ERROR';
                break;

            case SessionErrorResponseCodeEnum.BadArgument:
                sessionErrorType = 'SESSION_BAD_ARGUMENT_ERROR';
                break;

            case SessionErrorResponseCodeEnum.BadConfiguration:
                sessionErrorType = 'SESSION_BAD_CONFIGURATION_ERROR';
                break;

            case SessionErrorResponseCodeEnum.Deprecated:
                sessionErrorType = 'SESSION_DEPRECATED_ERROR';
                break;

            case SessionErrorResponseCodeEnum.ExternalError:
                sessionErrorType = 'SESSION_EXTERNAL_ERROR';
                break;

            case SessionErrorResponseCodeEnum.HostUnavailable:
                sessionErrorType = 'SESSION_HOST_UNAVAILABLE_ERROR';
                break;

            case SessionErrorResponseCodeEnum.InternalError:
                sessionErrorType = 'SESSION_INTERNAL_ERROR';
                break;

            case SessionErrorResponseCodeEnum.NoSession:
                sessionErrorType = 'SESSION_NO_SESSION_ERROR';
                break;

            case SessionErrorResponseCodeEnum.NotAuthenticated:
                sessionErrorType = 'SESSION_NOT_AUTHENTICATED_ERROR';
                break;

            case SessionErrorResponseCodeEnum.NotAuthorized:
                sessionErrorType = 'SESSION_NOT_AUTHORIZED_ERROR';
                break;

            case SessionErrorResponseCodeEnum.NotAuthorizedDeviceType:
                sessionErrorType = 'SESSION_NOT_AUTHORIZED_DEVICE_TYPE_ERROR';
                break;

            case SessionErrorResponseCodeEnum.NotAuthorizedOutOfHome:
                sessionErrorType = 'SESSION_NOT_AUTHORIZED_OUT_OF_HOME_ERROR';
                break;

            case SessionErrorResponseCodeEnum.NotAuthorizedOutOfRegion:
                sessionErrorType = 'SESSION_NOT_AUTHORIZED_OUT_OF_REGION_ERROR';
                break;

            case SessionErrorResponseCodeEnum.NotRegistered:
                sessionErrorType = 'SESSION_NOT_REGISTERED_ERROR';
                break;

            case SessionErrorResponseCodeEnum.TooManyStreams:
                sessionErrorType = 'SESSION_TOO_MANY_STREAMS_ERROR';
                break;

            case SessionErrorResponseCodeEnum.TooManyStreamsForResource:
                sessionErrorType = 'SESSION_TOO_MANY_STREAMS_FOR_RESOURCE_ERROR';
                break;

            case SessionErrorResponseCodeEnum.UnknownLocation:
                sessionErrorType = 'SESSION_UNKNOWN_LOCATION_ERROR';
                break;

            default:
                break;
        }
        return sessionErrorType;
    }
}
